export const environmentProd = {
  b2b_access_token: 'jwt',
  b2b_refresh_token: 'refresh_token',
  b2c_access_token: 'token',
  b2c_refresh_token: 'refreshToken',
  buyer_access_token: 'buyer_token',
  b2c_profile: 'profile',
  b2c_language: 'PowerSiteLanguage',
  currency: 'PowerSiteCurrency',
  ojwt: 'ojwt',
  orefresh_token: 'orefresh_token',
  url_token: 'url_token',
  token_referrer: 'token_referrer',
  roles: 'roles',
  appInsightsKey: '91701170-8ed2-4624-93db-053e7187bc59',
  dismiss_app_banner: 'PowerSiteDismissAppBanner',
  b2b_clientId: 'd6e9db3113d0412ca4f9e87293e289b1',
  b2c_clientId: 'd5293879570c4e43b5ee79f159e5457b',
  applink: 'https://applink.properstar.com/link',
  dashboardLink: 'https://dashboard.properstar.com/',
  properstarLink: 'https://www.properstar.com',
  acsChatUrl: 'https://cs-communications-acs.europe.communication.azure.com',
}
